module.exports = __webpack_public_path__ + "media/end-game-success.3b2668a8.mp3";